
<div style="padding-top: 4px">
  <p-toast key="message"></p-toast>
  <p-steps
      [model]="items"
      [readonly]="true"
      [activeIndex]="activeIndex"
      (activeIndexChange)="onActiveIndexChange($event)"
      
  ></p-steps>
</div>
<br />
<ng-container *ngIf="activeIndex === 0">
  
<div>
  <div class="filter-container">    
    <div class="filter-row-2 flex align-items-end gap-3">
      <!-- Select All Checkbox -->
      <div class="search-container">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
          type="text"
          pInputText
          id="studentSearch"
          class="search-input"
          placeholder="Search Students"
          (input)="filter()"
          [(ngModel)]="studentSearchInput"
          appCapitalizeFirstLetter
          appNoLeadingSpace
          #studentSearch/>
        </span>
      </div>
    <!-- Select Tag Dropdown -->
        <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2" optionLabel="name"
            [(ngModel)]="selectedRoomId" filterBy="name"
            [options]="roomList" optionValue="id"
             [filter]="true" [placeholder]="'Select Classroom'"
             (onChange)="filterRoom()"
            #roomNameDropdown>
        </p-dropdown>
      <!-- Select Tag Dropdown -->
        <p-multiSelect appendTo="body" class="custom-dropdown-filter mr-2 " optionLabel="name"
            [(ngModel)]="selectedTagId" filterBy="name" [options]="tagList" optionValue="id"
            [filter]="true" placeholder="Select Tag" 
            (onChange)="filterTag()"
            #tagNameDropdown
            >
        </p-multiSelect>
    </div>
    
    <div class="filter-row-2 flex align-items-end gap-3">
      <div class=" field date-container">
        <label for="fromDate" class="block text-sm ml-1 label opacity-50	 ">Start Date</label>
        <input
          id="fromDate"
          type="date"
          pInputText
          placeholder="Start Date"
          class="form-control search-input"
          style="height: 62%;"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="fromDate"
          [min]="todayDate"
          (change)="onClickDate('fromDate')"
        />
      </div>
      
      <div class="field date-container">
        <label for="toDate" class="block text-sm ml-1 label opacity-50	">End Date</label>
        <input
          id="toDate"
          type="date"
          pInputText
          placeholder="End Date"
          class="form-control search-input"
          style="height: 62%;"
          [(ngModel)]="toDate"
          [ngModelOptions]="{standalone: true}"
          [min]="fromDate"
          (change)="onClickDate('toDate')"
        />
      </div>
        <button pButton type="button" 
        label="Clear All"
        (click)="onClear()" 
        class="clear-btn"></button>

    </div>
    <div class="filter-row-3 flex align-items-center justify-content-between w-full py-2">
      <!-- Left side: Checkbox -->
      <div class="flex align-items-center gap-2">
        <p-checkbox
          [binary]="true"
          [(ngModel)]="selectAllStudents"
          (onChange)="toggleAllSelection();checkboxChanged()"
        ></p-checkbox>
        <label for="selectAll" class="mb-0">Select All</label>
      </div>
      
      <!-- Right side: Note -->
      <!-- <div class="note-container">
        <div class="student-profile-page__note--box">
          <p class="p-2 m-0">Students will be refreshed on basis of date selection. Please select Date first.</p>
        </div>
      </div> -->
    </div>
  
  </div> 
  <p-dataView [value]="studentList" >

      <ng-template let-student pTemplate="listItem">
        <div class="student-item"
        [ngClass]="{ 'selected-student': student.selected }">
          <img
              [src]="student.profileimg || 'assets/placeholder.png'"
              alt="Student Photo"
              class="profile-pic"
              *ngIf="student.profileimg != null; else noImageFound1"
          />
         <ng-template #noImageFound1>
                        <div class="circle flex justify-content-center align-items-center mr-1"
                            [style.background-color]="getBackgroundColor(student.id)" >
                            {{ getInitials(student.fullName) }}
                        </div>
           </ng-template>
          <span class="student-name text-primary">{{ student.fullName }}</span>
          <p-checkbox  [binary]="true"
            [(ngModel)]="student.selected"
            [value]="student"
            (onChange)="
                toggleSelection(student);
                isSelected(student);
                checkboxChanged();">
            </p-checkbox>
        </div>
      </ng-template>

    <ng-template pTemplate="empty">
      <div class="row" style="justify-content: center;">
        <span class="text-primary text-center">
          No result found
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex align-items-center justify-content-center gap-3">
            <button pButton pRipple 
              type="button" label="Cancel"
              class="p-button-outlined"
              (click)="ref.close()"
            ></button>
            <button pButton pRipple 
              label="Continue" id="save"
              (click)="complete()"
              ></button>
        </div>
    </ng-template>
</p-dataView>


</div>
</ng-container>

<ng-container *ngIf="activeIndex === 1">
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <div class="custom-student-list">
        <div class="custom-student-card" *ngFor="let student of selectedStudentList">
          <div class="custom-student-row">
            <!-- Student Info (40%) -->
            <div class="custom-student-info">
              <!-- Student Profile Image -->
              <img
                *ngIf="student.profileimg; else customNoImageFound"
                [src]="student.profileimg"
                alt="Student Photo"
                class="custom-student-photo"
              />
              <ng-template #customNoImageFound>
                <div class="circle flex justify-content-center align-items-center mr-1"
                    [style.background-color]="getBackgroundColor(student.id)" >
                    {{ getInitials(student.fullName) }}
                </div>
              </ng-template>
      
              <!-- Student Name -->
              <span class="custom-student-name">{{ student.fullName }}</span>
      
              <!-- Delete Button -->
              <button class="custom-delete-btn" (click)="onRemoveStud($event, student)">
                <i class="pi pi-trash"></i>
                <p-confirmPopup key="confirm2"></p-confirmPopup>
              </button>
            </div>
      
            <!-- Absent Notes (60%) -->
            <div class="custom-absent-note">
              <input type="text" class="custom-absent-note-input" placeholder="Enter Absent Notes" [(ngModel)]="student.absentNote" />
            </div>
          </div>
        </div>
      </div>
      
      
    </div>
  </div>
</div>
  <div class="flex align-items-center justify-content-center gap-3">
      <button pButton pRipple 
        type="button" label="Go Back"
        class="p-button-outlined"
        (click)="prevPage()"
        [disabled]="fromOverView"
      ></button>
      <button pButton pRipple 
        label="Save" id="save"
        [disabled]="selectedStudents.length == 0"
        (click)="onSave()"
        ></button>
  </div>

</ng-container>
